import { render, staticRenderFns } from "./assignClinic.vue?vue&type=template&id=c4ce2a44&"
import script from "./assignClinic.vue?vue&type=script&lang=js&"
export * from "./assignClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports